export default "__VITE_ASSET__CtdS$jUj__"